import {
  Flex,
  Heading,
  Link,
  Tag,
  TagLabel,
  Text,
  toast,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import EditView from "../../components/EditView";
import Meta from "../../components/Meta";
import {
  useSchemaMutation,
  useSchemaQuery,
} from "../../react-apollo-introspection";
import { authAtom } from "../../state/auth";

import { CREATE, EDIT, FETCH } from "./graphql";

import { setup } from "./setup";

const Index = ({ title }) => {
  const toast = useToast();
  const params = useParams();
  const [updateStatus, { loading: loadingEdit }] = useSchemaMutation(EDIT);
  const [fetchData, { data, loading, error }] = useSchemaQuery(
    "arearequests_FindById"
  );
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: 30,
      minHeight: 30,
      minWidth: 50,
      boxShadow: "none",
    }),
    menu: (base) => ({
      ...base,
      minWidth: 200,
    }),
    option: (base) => ({
      ...base,
      fontSize: 12,
    }),

    input: (base, state) => ({
      ...base,
      margin: 0,
      minWidth: state.selectProps.minWidth ? state.selectProps.minWidth : 30,
    }),
    valueContainer: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      minWidth: "300px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: 0,
      paddingBottom: 0,
    }),
    placeholder: (base, state) => ({
      ...base,
      fontSize: 12,
      color: state.selectProps.hasBg ? "#2b6da3" : "rgba(0,0,0,0.5)",
    }),
    singleValue: (base, state) => ({
      ...base,
      fontSize: 12,
      fontWeight:
        state.selectProps.hasBg || state.selectProps.isOperator
          ? "bold"
          : "normal",
      backgroundColor: state.selectProps.isOperator ? "#dfeaff" : "white",
      color: state.selectProps.isOperator ? "#2563d6" : "black",
      borderRadius: "4px",
      border: "1px solid",
      borderColor: state.selectProps.isOperator ? "#467ee6" : "white",
      paddingLeft: state.selectProps.isOperator ? "4px" : "0px",
      paddingRight: state.selectProps.isOperator ? "4px" : "0px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      "*": {
        padding: 0,
      },
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: 10,
      fontWeight: "500",
      color: "white",
      backgroundColor: "#366DDD",
    }),
  };

  const options = [
    {
      label: "Pending",
      value: "pending",
    },
    { label: "Completed", value: "completed" },
  ];

  const [auth, setAuth] = useRecoilState(authAtom);
  const type = params.type.charAt(0).toUpperCase() + params.type.slice(1);

  const handleChange = (e) => {
    updateStatus({
      variables: {
        _id: params?.id,
        record: {
          status: e.value,
        },
      },
      onError() {
        toast({
          status: "error",
          title: "Error Updating Area Request Status",
          position: "bottom-right",
        });
      },
      onCompleted() {
        toast({
          status: "success",
          title: "Area Request Status has been updated",
          position: "bottom-right",
        });
      },
    });
  };

  return (
    // <>hello</>
    <Meta title={` ${type} ${title}`}>
      <EditView
        fetchData={fetchData}
        loading={loading}
        error={error}
        data={data}
        setup={setup}
        gqlFetch={FETCH}
        gqlEdit={EDIT}
        gqlCreate={CREATE}
        ignoreValues={["users"]}
      >
        <Flex w="80%" display={"flex"} flexDirection={"column"}>
          <Heading>New Area Request</Heading>

          <Flex
            display={"flex"}
            flexDirection={"column"}
            bg="white"
            rounded="8px"
            p="20px"
            mt="10px"
            justifyContent={"start"}
            gap="40px"
          >
            <Flex
              fontWeight={"800"}
              display={"flex"}
              alignItems={"start"}
              gap="20px"
              w="full"
              flexDirection={"column"}
            >
              Status
              <Select
                styles={customStyles}
                onChange={(e) => handleChange(e)}
                isFullWidth
                //  formatOptionLabel={(op) => op.createdAt}
                // value={defaultValue ? defaultValue : defaultOptions}
                // options={options}
                defaultValue={options.find(
                  (el) => el.value === data?.arearequests_FindById?.status
                )}
                options={options}
                menuPlacement="auto"
              />
            </Flex>
            <Flex
              fontWeight={"800"}
              display={"flex"}
              alignItems={"start"}
              gap="20px"
              w="full"
              flexDirection={"column"}
            >
              Requested Emails:
              <Flex flexWrap={"wrap"}>
                {data?.arearequests_FindById?.requests.length > 0 &&
                  data?.arearequests_FindById?.requests?.map((req) => (
                    <Tag m="5px" size="lg" variant="solid" colorScheme="teal">
                      <TagLabel>
                        <Text
                          as="a"
                          target="_blank"
                          href={`mailto:${req.email}?subject=Area Request Notification`}
                          textDecoration={"underline"}
                        >
                          {req.email?.toLowerCase() || ""}
                        </Text>
                      </TagLabel>
                    </Tag>
                  ))}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </EditView>
    </Meta>
  );
};

export default Index;
